import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store/index";
import VueClipboard from "vue-clipboard2";
require("./css/style.css");

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js